export interface IRoomUnreadProps {
  roomId: string
  count: number
}

export default class RoomUnreadEntity {
  private _props: IRoomUnreadProps

  constructor(props?: IRoomUnreadProps | null) {
    this._props = EmptyRoomUnreadPropsFactory(props)
  }

  get props(): IRoomUnreadProps {
    return this._props
  }

  get clone(): IRoomUnreadProps {
    return structuredClone(this._props)
  }

  get roomId(): string {
    return this._props.roomId
  }

  get count(): number {
    return this._props.count
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyRoomUnreadPropsFactory = (props?: Partial<IRoomUnreadProps> | null): IRoomUnreadProps => ({
  roomId: '',
  count: 0,
  ...props
})
